import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const usePacingGet = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["PacingReport", filters],
    () => {
      const eventId = filters.events?.[0] ?? null;
      const asOfDate = filters.asOfDate || null;

      return makeAuthedRequest(
        `v1/reporting/pacing-overview/year/${filters.year}/eventType/${encodeURIComponent(
          filters.type
        )}/event/${eventId}/asOf/${asOfDate}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};